/* Filtros y ordenamiento de colecciones/búsqueda (Section Rendering API) */
class FacetsForm extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.section;
    const onChange = window.Nova.debounce((e) => this.submit(e), 450);
    this.addEventListener('change', onChange);
    this.addEventListener('input', (e) => {
      if (e.target.matches('[data-price-input]')) onChange(e);
    });
    this.addEventListener('submit', (e) => {
      e.preventDefault();
      this.submit(e);
    });
  }

  buildQuery() {
    // Combina el formulario de filtros y el de ordenamiento
    const forms = document.querySelectorAll(`facets-form[data-section="${this.sectionId}"] form`);
    const params = new URLSearchParams();
    forms.forEach((form) => {
      new FormData(form).forEach((value, key) => {
        if (value !== '') params.append(key, value);
      });
    });
    return params.toString();
  }

  async submit() {
    await FacetsForm.render(this.sectionId, this.buildQuery());
  }

  static async render(sectionId, query) {
    const container = document.querySelector('.product-grid-container');
    container && container.classList.add('is-loading');
    const url = `${window.location.pathname}?section_id=${sectionId}${query ? `&${query}` : ''}`;
    try {
      const res = await fetch(url);
      const doc = window.Nova.parseHTML(await res.text());
      ['[data-facets-results]', '[data-facets-filters]', '[data-facets-active]', '[data-facets-count]'].forEach((sel) => {
        const fresh = doc.querySelector(sel);
        document.querySelectorAll(sel).forEach((el) => {
          if (!fresh) return;
          // Mantiene abiertos los grupos que el usuario tenía abiertos
          const openIds = Array.from(el.querySelectorAll('details[open]')).map((d) => d.id);
          el.innerHTML = fresh.innerHTML;
          openIds.forEach((id) => {
            const d = id && el.querySelector(`#${CSS.escape(id)}`);
            if (d) d.open = true;
          });
        });
      });
      history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}`);
      window.Nova.init(document.querySelector('[data-facets-results]') || document);
    } catch (err) {
      window.location.search = query;
    } finally {
      container && container.classList.remove('is-loading');
    }
  }
}
customElements.define('facets-form', FacetsForm);

document.addEventListener('click', (e) => {
  const link = e.target.closest('[data-facet-link]');
  if (!link) return;
  e.preventDefault();
  const sectionId = link.dataset.facetLink;
  const url = new URL(link.href, window.location.origin);
  FacetsForm.render(sectionId, url.searchParams.toString());
});
